import BannerInfo from 'components/BannerInfo';
import Card from 'components/Card';
import ValidationMailSent from 'components/ValidationMailSent';

const AwaitingValidation = () => {
  return (
    <>
      <Card>
        <ValidationMailSent />
      </Card>
      <BannerInfo />
    </>);
};

export default AwaitingValidation;
